import { fork, put, all, takeEvery } from 'redux-saga/effects';
import { updateMacZipCodeSagaValuesType } from '../../Epics/Contributions/Pages/MakeAContribution/actionTypes';
import { setCityField } from '../../Epics/NPA/Pages/actionTypes';
import * as actionTypes from "./actionTypes";

export function* fetchZipCodeDataWorker(fetchPayload) {
  yield put({ type: actionTypes.zipcodeDataLoadingType, zipTitle: fetchPayload.zipTitle });
  try {
    let response = fetchPayload.payload;
    /** Start:  This is for Open Additional Account Checking */
    if (fetchPayload.zipTitle.includes('oaa-')) {
      yield put({
        type: setCityField,
        payload: true
      });
    } /** End */
    if (response.length === 0) {
      yield put({
        type: actionTypes.resetAllZipFielsType,
        zipTitle: fetchPayload.zipTitle
      });

      /** To handle zipcode for MAC */
      if (fetchPayload.zipTitle.includes('mac-')) {
        yield put({
          type: updateMacZipCodeSagaValuesType,
          zipTitle: fetchPayload.zipTitle,
          clear: true
        });
      }

    } else {
      let data = response[0];
      if (data) {
        let result = data.address_components;
        let zipCode;
        let country;
        let state;
        let city;
        let neighbourCity;
        for (let i = 0; i < result.length; i++) {
          if (result[i].types.indexOf('postal_code') >= 0) {
            zipCode = result[i].long_name;
          }
          if (
            result[i].types.indexOf('country') >= 0 &&
            result[i].types.indexOf('political') >= 0
          ) {
            country = 'United States'; // changing statically since some zipcodes have different country name ex: Virgin Islands
          }
          if (
            result[i].types.indexOf('administrative_area_level_1') >= 0 &&
            result[i].types.indexOf('political') >= 0
          ) {
            state = result[i].long_name;
          }
          if (
            result[i].types.indexOf('locality') >= 0 &&
            result[i].types.indexOf('political') >= 0
          ) {
            city = result[i].long_name;
          }
          if (
            result[i].types.indexOf('neighborhood') >= 0 &&
            result[i].types.indexOf('political') >= 0
          ) {
            neighbourCity = result[i].long_name;
          }
          if(city === null || city === undefined || city === '') {
            city = neighbourCity;
          }
        }
        let zipCodeData = {
          zipCode: zipCode,
          city: city,
          state: state,
          country: country
        };
        yield put({
          type: actionTypes.zipcodeDataType,
          payload: zipCodeData,
          zipTitle: fetchPayload.zipTitle
        });

        /** To handle zipcode for MAC */
      if (fetchPayload.zipTitle.includes('mac-')) {
        yield put({
          type: updateMacZipCodeSagaValuesType,
          zipTitle: fetchPayload.zipTitle,
          clear: false,
          data: zipCodeData
        });
      }

      } else {
        yield put({
          type: actionTypes.resetAllZipFielsType,
          zipTitle: fetchPayload.zipTitle
        });

        /** To handle zipcode for MAC */
      if (fetchPayload.zipTitle.includes('mac-')) {
        yield put({
          type: updateMacZipCodeSagaValuesType,
          zipTitle: fetchPayload.zipTitle,
          clear: true
        });
      }
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchZipCodeDataWatcher() {
  yield takeEvery(actionTypes.fetchZipcodeDataType, fetchZipCodeDataWorker);
}

export default function* commonZipCodeSagaWatcher() {
  yield all([fork(fetchZipCodeDataWatcher)]);
}
